export enum QualityType {
    "q360" = "360",
    "q480" = "480",
    "q720" = "720",
    "q1080" = "1080",
}
